<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Update Meter'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>

  <mat-tab-group>
    <mat-tab label="Update Usage">
      <div class="ttmodal__body">


          <mat-form-field class="input">
            <input matInput [min]= "lastUpdateTime" [max] = "maxDate" readonly [matDatepicker]="myDatepicker" placeholderout="Date of Reading" [(ngModel)]="dateOfReading" >
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="input">
            <input matInput placeholder="{{'New SMU' | translate | async}}"  type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="smuChangeTo" [formControl]="smuReadingInput"
              min="smuPrechange" ngDefaultControl required>
          </mat-form-field>
          <div *ngIf="smuReadingInput.errors && (smuReadingInput.dirty || smuReadingInput.touched)">
            <mat-error *ngIf="smuReadingInput.errors.required">{{'SMU Reading is required'| translate | async}}</mat-error>
            <mat-error *ngIf="smuReadingInput.errors.min">{{'New SMU must be greater than previous SMU'| translate | async}}</mat-error>
          </div>
        
          <mat-form-field class="input" *ngIf="!IsRopeshovel && DistanceEnabled ">
            <input matInput placeholder="New Forward Distance"  type="number" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="doeFChangeTo" (ngModelChange)="calculateTotal()" [formControl]="doeFReadingInput"
             ngDefaultControl>
          </mat-form-field>

           <mat-form-field class="input" *ngIf="!IsRopeshovel && DistanceEnabled ">
            <input matInput placeholder="New Reverse Distance"  type="number" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="doeRChangeTo" (ngModelChange)="calculateTotal()" [formControl]="doeRReadingInput"
              ngDefaultControl>
          </mat-form-field>

         <mat-form-field class="input" *ngIf="!IsRopeshovel && DistanceEnabled">
  <input matInput placeholder="Total Distance"
         type="number"
         style="background: white; border: 0px solid #ffffff !important;"
         [(ngModel)]="TotalDistance"
        
         
         ngDefaultControl>
</mat-form-field>

        <mat-form-field class="input">
          <input matInput placeholder="{{'BCM' | translate | async}}"  type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="bcmChangeTo" [formControl]="bcmReadingInput"
          min="bcmPrechange" ngDefaultControl>
        </mat-form-field>

        <div *ngIf="bcmReadingInput.errors && (bcmReadingInput.dirty || bcmReadingInput.touched)">
          <mat-error *ngIf="bcmReadingInput.errors.min">{{'New BCM must be greater than previous BCM'| translate | async}}</mat-error>
        </div>

        <mat-form-field class="input">
          <input matInput placeholder="{{'Tonnage' | translate | async}}"  type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="tonChangeTo"  [formControl]="tonReadingInput"
          min="tonPrechange" ngDefaultControl>
        </mat-form-field>

        <div *ngIf="tonReadingInput.errors && (tonReadingInput.dirty || tonReadingInput.touched)">
          <mat-error *ngIf="tonReadingInput.errors.min">{{'New Tonnage must be greater than previous Tonnage'| translate | async}}</mat-error>
        </div>
    
      </div>
      <div class="ttmodal__footer">
        <button mat-raised-button (click)="onNoClick()">{{'Cancel'| translate | async}}</button>
        <button mat-raised-button color="warn" [class.loading]="saving" (click)="updateMeterClicked()" [disabled]= "smuReadingInput.errors || tonReadingInput.errors || bcmReadingInput.errors">
          <span class="material-icons button__icon">check</span>
          <span class="button__text">{{'Update Meter'| translate | async}}</span>
        </button>
      </div>
    </mat-tab>
    <mat-tab label="History">
     
      <div class="panel__content no-padding">
        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>{{'Type'| translate | async}}</th>
              <th>{{'Date'| translate | async}}</th>
              <th>{{'SMU'| translate | async}}</th>
              <!-- <th>BCM</th>
              <th>Tonnage</th> -->
            </tr>
          </thead>
          <tbody>
            <tr class="table-row-style" *ngFor="let item of SMUHistory" > 
              <td>{{item.ActionType}}</td>
              <td>{{item.sDate}}</td>
              <td>{{item.equipmentSMU}}</td>
              <!-- <td>{{item.equipmentBCM}}</td>
              <td>{{item.equipmentTON}}</td> -->
             
            </tr>
          </tbody>
    
    
        </table>
      </div>

      <div class="ttmodal__footer">
          <button mat-raised-button (click)="onNoClick()">{{'Cancel'| translate | async}}</button>
          
        </div>
    </mat-tab>
  </mat-tab-group>




  
</div>
